export default "__VITE_ASSET__3bb6dc9f__"